import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-187">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-188" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-189">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-190">
          L'Offerta Imperdibile
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(249,115,22,0.15)]" data-id="element-191">
          <div className="flex justify-center -mt-4 mb-2" data-id="element-192">
            <div className="bg-gradient-to-b from-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(251,191,36,0.5)]" data-id="element-193">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-194" />
              IL PIÙ SCELTO DAI DOCENTI
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-195">
            <h3 className="text-lg sm:text-xl font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-196">
              IL VALUE STACK COMPLETO:
            </h3>

            <div className="space-y-0 mb-5" data-id="element-197">
              {[{
              label: '6 Tomi Completi ECONOMIA PRO (400+ pagine)',
              price: '€120'
            }, {
              label: 'Bonus 1 — Inclusione Facile BES/DSA',
              price: '€47'
            }, {
              label: 'Bonus 2 — Excel Automatico per Docenti',
              price: '€67'
            }, {
              label: 'Bonus 3 — Ed. Civica & Economia Reale',
              price: '€47'
            }, {
              label: 'Bonus 4 — Registro Veloce + Griglie',
              price: '€37'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3" data-id="element-198">
                  <span className="text-gray-300 font-medium text-sm sm:text-base" data-id="element-199">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm sm:text-base" data-id="element-200">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-201">
                <span className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-202">
                  VALORE TOTALE:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-203">
                  €318
                </span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-204">
                <span className="text-sm font-bold text-gray-400 uppercase" data-id="element-205">
                  Prezzo normale:
                </span>
                <span className="text-base font-bold text-gray-400 line-through" data-id="element-206">
                  €97
                </span>
              </div>
            </div>

            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-207">
              <p className="text-brand-orange font-bold text-sm mb-2" data-id="element-208">
                🏆 Offerta di Lancio (Solo per oggi):
              </p>
              <div className="flex justify-center items-center gap-2 mb-1" data-id="element-209">
                <span className="text-2xl" data-id="element-210">💥</span>
                <span className="text-3xl sm:text-4xl font-black text-brand-cream" data-id="element-211">
                  Solo €19,90
                </span>
                <span className="text-2xl" data-id="element-212">💥</span>
              </div>
              <p className="text-xs text-gray-400 mt-1" data-id="element-213">
                (Pagamento unico · Accesso a vita)
              </p>
            </div>

            <div className="flex justify-center mb-5" data-id="element-214">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-215">
                <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-216" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-217">
                  ⏰ Prezzo di lancio — salirà presto
                </span>
              </div>
            </div>

            <CTAButton href={CART_URL} className="w-full mb-5" data-id="element-218">
              SÌ! VOGLIO IL SISTEMA ECONOMIA PRO COMPLETO
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-219">
              <span className="flex items-center gap-1" data-id="element-220">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-221" /> Accesso
                Immediato
              </span>
              <span className="text-gray-600" data-id="element-222">•</span>
              <span className="flex items-center gap-1" data-id="element-223">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-224" /> Pagamento
                Unico
              </span>
              <span className="text-gray-600" data-id="element-225">•</span>
              <span className="flex items-center gap-1" data-id="element-226">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-227" /> Garanzia
                14 Giorni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}